import React from 'react'
import { Button, Card, Col, Drawer, Form, notification, Row, Select, DatePicker, TimePicker } from 'antd'
import _ from 'lodash'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
const Option = Select.Option

@Form.create()
class ApplyLeave extends React.Component {
    state = {
        visible: true,
        shortLeave: false,
        workFromHome: false,
        leaveTypes: [],
        loading: false,
        leaveType: '',
        startDate: moment(),
        endDate: moment(),
        startTime: moment(),
        endTime: moment(),
        joinedMonths: 0,
        noticePeriod: false,
        allUsers: [],
        lastLeaveTakenDate: null,
    }

    // getUserResignationDetail = async() =>{
    //     let {data} = await Request.getUserApprovedResignation()
    //     if(data.length>0) {
    //         this.setState({noticePeriod:true})
    //     }
    // }


    getAllUsers = async () => {
        let params = {
            sortField: '_id',
            sortOrder: 'ascend',
            results: 200,
            active: true,
            userType: { $ne: "Student" }
        };

        let response = await Request.loadUser({ ...params, regExFilters: ['name'] })
        let userArray = [];
        response.data.map((user, index) => {
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({ allUsers: userArray })
    }

    // getJoiningPeriod = async() =>{
    //     let {data}  = await Request.getUserProfileByUserId();
    //     let dateOfJoin = moment(data.dateOfJoining).startOf('day')
    //     let todayDate = moment().startOf('day')
    //     let joinedMonths = todayDate.diff(dateOfJoin, 'months');
    //     this.setState({joinedMonths})
    // }

    componentDidMount() {
        this.getAllUsers();
        // this.getJoiningPeriod();
        // this.getUserResignationDetail();
        // this.getLeaveDetails();
        this.getUserTotalLeaves();
    }

    handleLeaveType = (data) => {
        if (data === "HD(Half Day)") {
            this.setState({ shortLeave: true })
        } else if (data !== 'HD(Half Day)') {
            this.setState({ shortLeave: false })
        }
        this.setState({ leaveType: data })
    }

    getUserTotalLeaves = async () => {
        let params = {
            month: moment().format('YYYY-MM'),
        }
        params.status = { $nin: ["Withdrawn", "Disapproved"] }
        let response = await Request.getLeaveApplications(params);
        if (response.data && response.data.length > 0) {
            let { startDate } = response.data[response.data.length - 1]
            let lastLeaveTakenDate = moment(startDate, "YYYY-MM-DD");
            this.props.form.setFieldsValue({ lastLeave: lastLeaveTakenDate })
        }
    }

    // async getLeaveDetails () {
    //     let sandwichLeaveDetails = await this.getSandwichLeaveDetails();
    //     let casualLeaveDetails = await this.getCasualLeaveDetails();
    //     if(casualLeaveDetails.total >=1 && sandwichLeaveDetails.total < 2 && this.state.joinedMonths>=3 && this.state.noticePeriod !== true ) {
    //         this.setState({leaveTypes:['LWP(Leave Without Pay)', 'HD(Half Day)', 'WFH(Work From Home)']})
    //     }else if(casualLeaveDetails.total >=1 && sandwichLeaveDetails.total >= 2 && this.state.joinedMonths>=3 && this.state.noticePeriod !== true  ) {
    //         this.setState({leaveTypes:['LWP(Leave Without Pay)', 'HD(Half Day)','WFH(Work From Home)']})
    //     }else if(sandwichLeaveDetails.total >= 2 && this.state.joinedMonths>=3 && this.state.noticePeriod !== true ) {
    //         this.setState({leaveTypes:['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)','WFH(Work From Home)']})
    //     }else if(this.state.joinedMonths>=3 && this.state.noticePeriod !== true ) {
    //         this.setState({leaveTypes:['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)','WFH(Work From Home)']})
    //     }else {
    //         this.setState({leaveTypes:['LWP(Leave Without Pay)','WFH(Work From Home)', 'HD(Half Day)']})
    //     }
    // }

    // async getSandwichLeaveDetails () {
    //     let data = {
    //         leaveType:'Sandwich Leave',
    //         leaveYear:moment().format('YYYY'),
    //         status:'Approved'
    //     }
    //     let response = await Request.getUserLeaves(data);
    //     return response
    // }

    // async getShortLeaveDetails() {
    //     let data = {
    //         leaveType:'HD(Half Day)',
    //         leaveYearMonth:moment().format('YYYY-MM'),
    //         status:'Approved'
    //     }
    //     let response = await Request.getUserLeaves(data);
    //     return response
    // }
    // async getCasualLeaveDetails() {
    //     let data = {
    //         leaveType:'CL(Casual Leave)',
    //         leaveYearMonth:moment().format('YYYY-MM'),
    //         status:'Approved'
    //     }
    //     let response = await Request.getUserLeaves(data);
    //     return response
    // }

    fetchLeaveTypes = async (date) => {
        let data = {
            month: moment(date, 'YYYY-MM-DD').format('YYYY-MM'),
        }
        let response = await Request.getLeaveTypes(data);
        this.setState({ leaveTypes: response });
    }

    // handleDuration = (values) => {
    //     if(values.endTime) {
    //         let duration = moment(values.endTime).diff(this.state.startTime, 'hours', 'minute')
    //         this.setState({endTime:values.endTime})

    //     }
    //     if(values.endDate) {
    //         this.setState({endDate:values.endDate})
    //     }
    // }

    // handleEndTime = (value) => {
    //     console.log(value)
    // } 


    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        e.preventDefault();
        const { form } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                if (moment(values.endDate).isBefore(values.startDate)) {
                    notification.error({
                        message: 'End Date will not before Start Date'
                    })
                    return
                }
                this.setState({ loading: true });
                let response = await Request.applyLeave(values)
                this.setState({ loading: false });
                if (!response.error) {
                    this.onClose()
                    notification.success({
                        message: 'Success',
                        description: response.msg
                    })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: response.msg
                    })
                }
            }

        })
    }

    render() {
        let { shortLeave, leaveTypes, allUsers, workFromHome } = this.state
        const inputTypes = {
            fields: [
                {
                    label: 'Start Date',
                    key: 'startDate',
                    type: 'date',
                    required: true,
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day')),
                        onChange: (value) => {
                            this.fetchLeaveTypes(value);
                        }
                    },
                },
                {
                    label: 'Leave Type',
                    key: 'leaveType',
                    type: 'select',
                    options: leaveTypes,
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ leaveType: v })
                        if (v === 'HD(Half Day)') {
                            this.setState({ shortLeave: true, workFromHome: false })
                        } else if (v === 'WFH(Work From Home)') {
                            this.setState({ workFromHome: true, shortLeave: false })
                        } else {
                            this.setState({ shortLeave: false, workFromHome: false })
                        }
                    }
                },
                {
                    label: 'Start Time',
                    key: 'startTime',
                    type: 'time',
                    format: 'HH:MM:SS',
                    hidden: !shortLeave,
                    required: shortLeave,
                },
                {
                    label: 'End Date',
                    key: 'endDate',
                    type: 'date',
                    required: true,
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
                    }
                },
                {
                    label: 'End Time',
                    key: 'endTime',
                    type: 'time',
                    hidden: !shortLeave,
                    required: shortLeave,
                },

                {
                    label: 'Reason',
                    key: 'leaveReason',
                    type: 'text',
                    required: !workFromHome,
                    hidden: workFromHome
                },
                {
                    label: 'Last Leave Taken',
                    key: 'lastLeave',
                    type: 'date',
                    hidden: workFromHome
                },
                {
                    label: 'Emergency Task Going',
                    key: 'isEmergencyTask',
                    type: 'select',
                    options: ['Yes', 'No'],
                    required: !workFromHome,
                    hidden: workFromHome,
                    onChange: v => {
                        this.props.form.setFieldsValue({ isEmergencyTask: v })
                    }
                },
                {
                    label: 'Person Handling Work',
                    key: 'personHandlingWork',
                    type: 'select',
                    options: allUsers,
                    showSearch: true,
                    required: !workFromHome,
                    hidden: workFromHome,
                    onChange: v => {
                        this.props.form.setFieldsValue({ personHandlingWork: v })
                    }
                },
                {
                    label: 'Asset Details',
                    key: 'assetDetails',
                    type: 'textarea',
                    required: workFromHome,
                    hidden: !workFromHome
                }
            ]
        }
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const { visible } = this.state
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Leave Application Form
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}
                                    disabled={this.state.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ApplyLeave)
